module.exports = __webpack_public_path__ + "img/Ethan.cfe00e0e.png";